import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const SvgLoading02 = ({ ...props }: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      d="M12 2v4m0 12v4M6 12H2m20 0h-4m1.078 7.078L16.25 16.25M19.078 5 16.25 7.828M4.922 19.078 7.75 16.25M4.922 5 7.75 7.828"
      stroke="currentColor"
      fill="none"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default SvgLoading02;
